import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { 
  Box, 
  CircularProgress,  
  Table, 
  TableBody, 
  TableCell, 
  TableFooter, 
  TableHead, 
  TablePagination, 
  TableRow, 
  TableSortLabel, 
  Typography 
} from '@mui/material';

import TablePaginationActions from '../../../../components/utils/TablePaginationActions';
import useTablePaginationInit from '../../../../components/hooks/useTablePaginationInit';
import TableTimeStamps from '../../../../components/utils/TableTimeStamps';
import TopBar from '../../../../components/utils/TopBar';
import NA from '../../../../components/utils/NA';

import { 
  GetSmsActivitiesBIZnotifications 
} from '../../../../redux/actions/business/notifications/SmsActivitiesActions';

const SmsActivitiesPage = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["business.notifications"]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const [smsActivitiesList, setSmsActivitiesList] = useState([]);
  const [smsActivitiesTotal, setSmsActivitiesTotal] = useState(0);

  const [
    page, 
    rowsPerPage, 
    handleChangePage, 
    handleChangeRowsPerPage
  ] = useTablePaginationInit();

  const tableHeadingsList = [
    {
      label: "Id",
      sort: "id",
    },
    {
      label: "From",
      sort: "from",
    },
    {
      label: "To",
      sort: "to",
    },
    {
      label: "Content",
      sort: "content",
    },
    {
      label: "Api response",
      sort: "api_response",
    },
    {
      label: "Sent count",
      sort: "sent_count",
    },
    {
      label: "Time stamps",
      sort: "createdAt",
    }
  ];

  const handleSort = (value) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSort(value);
  };

  useEffect(() => {
    let query = ""
    if(search) query += `&search=${search}`;
    if(sort) query += `&field=${sort}`;
    if(sortDirection) query += `&order=${sortDirection}`;
    dispatch(GetSmsActivitiesBIZnotifications(page+1, rowsPerPage, query, setLoading));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, search, sort, sortDirection]);

  useEffect(() => {
    try {
      console.log(state);
      formatSmsActivitiesList(state.smsActivitiesList.records || []);
      setSmsActivitiesTotal(state.smsActivitiesList.total || 0);
    } catch (err) {}
  }, [state]);

  const formatSmsActivitiesList = (list) => {
    setSmsActivitiesList(list)
  };

  return (
    <Box>

      <TopBar
        title={"Sms Activities"}
        search={search}
        onSearchChange={(e) => {
          setSearch(e.target.value);
        }}
        button1Text={"Send SMS"}
        button1OnClick={() => {

        }}
        />
      
      {
        loading
        ?
        <Box height={"300px"} className="flexCenterCenterRow">
          <CircularProgress />
        </Box>
        :
          smsActivitiesList.length === 0
          ?
          <Box height={"300px"} className="flexCenterCenterRow">
            <Typography>No sms activity found</Typography>
          </Box>
          :
          <Table className="block">
            <TableHead>
              <TableRow>
                {
                  tableHeadingsList.map((heading, headingIndex) => (
                    heading.sort === null
                    ?
                    <TableCell
                      key={headingIndex}>{heading.label}</TableCell>
                    :
                    <TableCell
                      key={headingIndex}>
                      <TableSortLabel
                        active={sort === heading.sort ? true : false}
                        direction={sortDirection}
                        onClick={() => {
                          handleSort(heading.sort);
                        }}
                      >
                        {heading.label}
                      </TableSortLabel>
                    </TableCell>
                  ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                smsActivitiesList.map((row, index) => (
                  <TableRow 
                    key={index}>
                    <TableCell>
                      <Typography
                        variant='caption'
                        color={"grey"}>
                        {row.id || <NA />}
                      </Typography>
                    </TableCell>
                    <TableCell>{row.from || ""}</TableCell>
                    <TableCell>
                      <Box>{row.to_name || ""}</Box>
                      <Typography color={"grey"}>
                        <i>{row.to || ""}</i>
                      </Typography>
                    </TableCell>    
                    <TableCell>
                      <Typography
                        className='longText'
                        maxWidth={"300px"}>
                          {row.content || ""}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        className='longText'
                        maxWidth={"300px"}>
                        {row.api_response || ""}
                      </Typography>
                    </TableCell>
                    <TableCell>{row.sent_count + "" || ""}</TableCell>
                    <TableCell>
                      <TableTimeStamps
                        createdAt={row.createdAt}
                        updatedAt={row.updatedAt}
                        />
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{ borderBottom: 0 }}
                   rowsPerPageOptions={[5, 10, 25, 50, 100]} 
                  colSpan={10}
                  count={smsActivitiesTotal}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page'
                    },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  />
              </TableRow>
            </TableFooter>
          </Table>
      }
    </Box>
  )
}

export default SmsActivitiesPage;